// src/admin/components/StatCard.jsx
import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function StatCard({ label, value, icon, to }) {
  const navigate = useNavigate();
  const inner = (
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
        {icon}
        <Typography variant="body2">{label}</Typography>
      </Box>
      <Typography variant="h4" sx={{ mt: 1 }}>{value}</Typography>
    </CardContent>
  );
  return (
    <Card sx={{ height: '100%' }}>
      {to ? <CardActionArea onClick={() => navigate(to)}>{inner}</CardActionArea> : inner}
    </Card>
  );
}
